import type { StaticTextLookup } from 'src/translators/static-text-lookup';

export const staticTextLookup: StaticTextLookup = {
  FAQs: "FAQs",
  aBasketHasBeenCreatedFor: "A basket has been created for %firstNameAndNumber%",
  aCopyOfThisGuaranteeShouldBeRetained: "A copy of this guarantee should be retained by the customer, it will be sent via email confirmation",
  about: "About",
  aboutYou: "About You",
  accessToClubsAndSpaRetreatsParagraph1: "Platinum membership will also give you access to other David Lloyd Clubs.\nSee below for details of the Clubs you'll be able to access.",
  accessToClubsAndSpaRetreatsParagraph2: "Plus, if the Club has a Spa Retreat, this will also include\naccess to the Spa Retreat facilities.",
  accessToClubsAndSpaRetreatsParagraph3: "Click here for a list of Clubs with Spa Retreat.",
  accessToClubsNearYou: "Your access to Clubs near you:",
  accessToOtherClubs: "Access to other Clubs",
  accountHoldersName: "Account holder's name",
  accountNumber: "Account number",
  activating: "Activating",
  addPartnerAmount: "Add a partner %amount%",
  addSelectedPromotion: "Add selected promotion",
  addToCalendar: "Add To Calendar",
  addYourAssociates: "Add your partner and children",
  addYourChildren: "Add your children",
  addYourPartner: "Add your partner",
  additionalDetailsSecondErrorMessage: "Sorry, we're unable to take your details online at the moment, we'll take these on your first visit to the club.",
  additionalMembers: "Additional members",
  additionalMemberships: "Additional memberships",
  address: "Address",
  addressAutocompletePlaceholder: "Please select your address below",
  addressAwaitingPostcodePlaceholder: "Please enter your postcode first",
  addressCouldNotBeVerified: "We couldn't find that address. Please check the details, or select your address from the suggestions.\n\nIf the issue persists, please speak to %email%.",
  addressLine1: "Address line 1",
  addressLine2: "Address line 2",
  addressLinePlaceholder: "Enter your address",
  addressNoResults: "No results found. Try entering a different part of the address",
  adultMembers: "Adult Members",
  adults: "Adults",
  afterSchool: "After School",
  agreementTextConfirmationTextAdult: "I confirm that I am over 18 and I have read and agree to the Health Declaration.",
  agreementTextConfirmationTextChild: "I confirm that I am over 18 and I have read and agree to the Health Declaration on behalf of my child.",
  agreementTextConfirmationTextPrimary: "I confirm that I have read and agree to the Terms and Conditions and Health Declaration.",
  agreementTextHealthDeclarationOpenText: "Read the health declaration",
  agreementTextIntroduction: "We recommend that you take the time to read the information below before you complete your application. Please note: Proof of identity will be required on your first visit to club including photo id, proof of address & bank details",
  agreementTextIntroductionDigitalSignatureParagraph1: "Please take the time to review the information below.",
  agreementTextIntroductionDigitalSignatureParagraph2: "You will need to confirm that you have reviewed, read and agree to the Terms and Conditions and Health Declaration before submitting your application.",
  agreementTextIntroductionDigitalSignatureParagraph3: "In the next step you will be asked to upload photo ID to complete your membership.",
  agreementTextIntroductionDigitalSignatureParagraph4: "Acceptable photo ID: National ID Card, Passport or Residence Card.",
  agreementTextTermsAndConditionsOpenText: "Read the terms and conditions",
  allAgesWelcome: "All ages welcome",
  allFacilities: "All Facilities",
  alsoAtClub: "Also at %clubName%",
  amountSubjectToChangeAfterPromotionalPeriod: "Amount is subject to change at the end of the promotional period",
  amountSubjectToPendingPriceRise: "The amount stated is subject to any pending price rise, refer with the club team for further details.",
  and: "and",
  annualOnJoiningTheClubPayment: "On joining the club you will be asked to make a payment comprising of a joining fee, a pro rata payment for the remainder of this month (if appropriate) and payment covering the cost of membership for 12 calendar months. If you wish to enhance your membership experience you can add on additional products such as personal training or coaching, this can also be paid today.",
  annually: "Annually",
  anythingElseYoudLikeUsToKnow: "Anything else you'd like us to know?",
  anytimeClubAccess: "Anytime club access",
  appQrCodeInstructions: "Simply line up your phone camera over the code, and once it's recognised tap the link to download the %brandName% app.",
  appUpdateRequired: "App Update Required",
  appointmentAlreadyCancelled: "Your appointment has been cancelled.",
  areYouSureYouDoNotWantToBeContacted: "Are you sure you don't want us to contact you via email or text message?",
  associatesWereReset: "Unfortunately this package does not support all of the additional members you had selected - please choose another package if you wish to include those members.",
  atClub: "At %clubName%",
  atHomeDigitalContent: "@home digital content including Live and on-demand content, educational seminars and trainer tips",
  atUnit: "At %unitName%",
  availablePromotions: "available promotions",
  availableSlot: "%numberOfSlots% available slot",
  availableSlots: "%numberOfSlots% available slots",
  awaitingPayment: "Awaiting payment",
  back: "Back",
  backToTop: "Back to top",
  bankDetailsNotVerifiedSubtitle: "We couldn't verify the bank details you entered. Please double-check them and try again, or contact %email% if you need a hand.",
  beforeYouBecomeAMember: "Before you become a member, let us show you how you can get the most out of this club",
  bestValue: "Best value",
  bookAClass: "Book a class",
  bookAClubWelcome: "Book a club welcome",
  bookAClubWelcomeError: "Sorry, something went wrong. Please get in touch, and we will find you a time.",
  bookANewTour: "Book a New Tour",
  bookATour: "Book a tour",
  bookATourError: "Sorry, something went wrong. Please get in touch, and we will find you a time.",
  bookATourHeader: "Book your tour",
  bookATourSubtext: "Choose a club from below to book a tour",
  bookOnTheMove: "Book on the move",
  bookYourClubWelcome: "Book your club welcome",
  bookYourClubWelcomeAt: "Book your club welcome at %clubName%",
  bookYourTour: "Book your tour",
  bookYourTourOf: "Book your tour of %clubName%",
  booked: "Booked",
  bookingYourClubWelcome: "Booking your club welcome...",
  bookingYourTour: "Booking your tour...",
  byClickingFinishYouAcceptDDConditions: "By clicking ‘%buttonText%’ you acknowledge that you are the bank account holder and the account does not require another person to authorise the debits on this account. If it is either a personal or business account and more than one person is required to authorise debits on this account, then please contact us directly.",
  call: "Call",
  cancel: "Cancel",
  cancelMyMembership: "Cancel my membership",
  cancelTour: "Cancel tour",
  cannotFindAddressManualEntry: "I can't find my address",
  cantFindASlot: "Can't find a slot?",
  careers: "Careers",
  changeClub: "Change club",
  changePreferences: "Change preferences",
  changeSelectedPackage: "Change selected membership",
  chatOnWhatsApp: "Chat on WhatsApp",
  checkBoxToContinue: "Please select this value to continue",
  checkYourAccessToASpecificClub: "Check your access to a specific Club:",
  child2AndUnder: "Child Membership:\n Up To 2 Years",
  child3To18: "Child Membership:\n 3-18 Years",
  childMembers: "Child Members",
  children: "Children",
  childrenOverview: "Children overview",
  chooseAClub: "Choose a Club",
  chooseAClubToRegisterForClubTrial: "Choose a club below",
  chooseHowYouPay: "Choose how you pay",
  chooseMembershipLength: "Choose the length of your membership",
  chooseNewTimeToLookAroundTheClub: "Choose a new time to take a look around the club.",
  chooseYourStartDate: "Choose your start date",
  clickHereIfYouAreNot: "Please click here if you are not %firstName%",
  close: "Close",
  closeDetails: "Close details",
  closed: "Closed",
  club: "Club",
  clubEmail: "Club email",
  clubFacilities: "Club Facilities",
  clubFinderSearchPlaceholder: "Enter a Location",
  clubOpeningHours: "Club opening hours",
  clubOpeningTimes: "Club opening times",
  clubOverview: "Club Overview",
  clubTourCancellation: "%clubPrefix% %clubName% tour cancellation",
  clubTourTime: "Club tour time",
  clubVideo: "Club Video",
  clubWelcomeMeetingTime: "Club welcome meeting time",
  comingSoon: "Coming Soon",
  completeDirectDebitPopupText: "Save time on your first visit by setting up your Direct Debit now",
  completeForm: "Please complete the below form.",
  completeItInClub: "Complete Direct Debit in Club",
  completeItNow: "Complete Direct Debit now",
  completeSEPAInClub: "Complete SEPA Direct Debit in Club",
  completeSEPANow: "Complete SEPA Direct Debit now",
  completeSEPAPopupText: "Save time on your first visit by setting up your SEPA Direct Debit now",
  complimentaryDailyDrinkInfo: "Enjoy a complimentary drink of your choice at your Club every day. Just show your membership card to redeem.",
  confirm: "Confirm",
  confirmChanges: "Confirm changes",
  confirmNoPaymentTaken: "Please confirm no payment has been processed",
  confirmPassword: "Confirm password",
  confirmPasswordPlaceholder: "Please confirm your new password",
  confirmPaymentTaken: "Please confirm payment has been processed",
  confirmationEmailOnItsWay: "A confirmation email is on its way.",
  confirmationEmailsWillBeSentAfterSelectingNext: "Then press %nextButton% to send membership emails",
  contact: "Contact",
  contactInformation: "Contact Information",
  contactMeToArrange: "Contact me to arrange",
  contactMeToReschedule: "Contact me to reschedule",
  contactNotPromotedMonthlyPaymentErrorSubtitle: "Setting up your membership takes a few moments behind the scenes. Please retry, but don't worry you won't be charged twice.",
  contactNotPromotedMonthlyPaymentErrorTitle: "Sorry, we're not quite as fast as you today!",
  contactPreferencesAfterPrivacyPolicy: "for full details. Just tick the boxes to keep in touch.",
  contactPreferencesBeforePrivacyPolicy: "We'd love to keep in touch and tell you more about our latest products, services and offers. If you agree, just tick the boxes below. You can always change your mind at any time. Please see our",
  contactTheClubForOpeningTimes: "Please contact the club for more information on opening times",
  "continue": "Continue",
  cookieConsentBannerAccept: "Accept",
  cookieConsentBannerAcceptSettings: "Accept All (Recommended)",
  cookieConsentBannerCloseLabel: "Save & Exit",
  cookieConsentBannerIntro: "Some of these cookies are essential for the website to work, while others help us to improve your experience by providing insights into how the site is being used.",
  cookieConsentBannerNecessaryDescription: "Necessary cookies enable core functionality. The website can’t function properly without these cookies and they can only be disabled by changing your browser preferences.",
  cookieConsentBannerNecessaryTitle: "Necessary cookies",
  cookieConsentBannerNotifyDescription: "We use cookies on our website to give you a better experience, to understand how it’s used and to personalise content and advertising.",
  cookieConsentBannerNotifyTitle: "Our site uses cookies",
  cookieConsentBannerOff: "Off",
  cookieConsentBannerOn: "On",
  cookieConsentBannerOptionalCookiesAnalyticsDescription: "Analytical cookies help us to improve the way the website works. They collect information on how the site is being used so that we can make the information you want easier to find.",
  cookieConsentBannerOptionalCookiesAnalyticsLabel: "Analytical cookies",
  cookieConsentBannerOptionalCookiesMarketingDescription: "Marketing cookies help us improve the relevancy of advertising campaigns you see. No personally identifiable information is recorded and visits are anonymous.",
  cookieConsentBannerOptionalCookiesMarketingLabel: "Marketing cookies",
  cookieConsentBannerOptionalCookiesPreferencesDescription: "Preference cookies enable a website to remember information that changes the way it behaves or looks, like your preferred language or region you're in.",
  cookieConsentBannerOptionalCookiesPreferencesLabel: "Preference cookies",
  cookieConsentBannerOptionalCookiesSocialMediaDescription: "We use social media cookies so that you can share or like content on sites including Facebook and Twitter. These cookies help to show how many times a page or piece of content has been shared.",
  cookieConsentBannerOptionalCookiesSocialMediaLabel: "Social media cookies",
  cookieConsentBannerReject: "Reject All",
  cookieConsentBannerRejectSettings: "Reject non-essential cookies",
  cookieConsentBannerSettings: "Settings",
  cookieConsentBannerStatementDescription: "For more information on the cookies we use, read our full",
  cookieConsentBannerStatementName: "Cookies Policy.",
  cookieConsentBannerThirdPartyDescription: "Consent for the following cookies could not be automatically revoked. Please follow the link(s) below to opt out manually.",
  cookieConsentBannerThirdPartyTitle: "Some cookies require your attention",
  cookieConsentBannerTitle: "Our site uses cookies",
  cookiePolicyDescription: "Our website uses cookies to improve your experience. By using the website you agree to our use of cookies.",
  cookiesPolicy: "Cookies Policy",
  coreStrengthAndHIIT: "Core, strength, and conditioning, HIIT, Wellness and wellbeing Yoga, Cycling",
  corporateFitness: "Unternehmensfitness",
  countryBelgium: "Belgium",
  countryFrance: "France",
  countryGermany: "Germany",
  countryIreland: "Ireland",
  countryItaly: "Italy",
  countryNetherlands: "Netherlands",
  countrySpain: "Spain",
  countrySwitzerland: "Switzerland",
  countryUnitedKingdom: "United Kingdom",
  county: "County",
  countyPlaceholder: "Enter your county",
  couple: "Couple",
  creche: "Crèche",
  creditorAddress: "Creditor address",
  creditorId: "Creditor ID",
  creditorName: "Creditor Name",
  currentBooking: "Current booking",
  date: "Date",
  dateAtTime: "%date% at %time%",
  dateOfBirth: "Date of birth",
  dateTimeDontWork: "Date & time don't work",
  days: "days",
  daysLabel: "days",
  daytime: "Daytime",
  detailsAddedToMembershipAccount: "These details will now be added to your membership account.",
  diamondPlusRequired: "Diamond Plus membership is required to access certain Spa Retreats",
  digitalSignatureAlreadyCompletedBody: "Your membership agreement has already been signed.",
  digitalSignatureAlreadyCompletedHeading: "You're all set for your first visit",
  digitalSignatureContactDetailsMissingPopup: "We cannot show your joining agreement yet because we need both an email address and phone number for your membership.\n\nPlease contact the Club so these details can be added, then try again.",
  digitalSignatureFailureContinuePrompt: "It looks like a technical issue has stopped us from capturing your digital agreement or verifying your ID.\n\nYou can still continue joining online today. However, your membership will stay conditional until you; complete agreement, present photo ID and provide any required membership photograph\n\nPlease note: access to the Club may be limited or paused until these steps are completed.",
  digitalSignatureMoreTimePopupContinueInClub: "Continue and complete in club",
  digitalSignatureMoreTimePopupDescription: "If you need more time, you can keep reviewing these now.\n\nOr you can continue without signing and we will confirm your agreement on your first visit to the Club.",
  digitalSignatureMoreTimePopupNeedMoreTime: "I need more time",
  digitalSignatureMoreTimePopupTitle: "Do you need more time to review your joining agreements?",
  digitalSignaturePageIntro: "Welcome to David Lloyd Clubs.\n\nWe’re really pleased that you’re starting your journey with us.\n\nBefore you can start your membership, you will need to confirm that you have reviewed, read and agree to the Terms and Conditions and Health Declaration.\n\nPlease note: proof of identity will be required when you visit the Club, including photo ID, proof of address and bank details.",
  directDebitClubOpens: "Your first direct debit will start when the club opens taking into account any promotions in place at time of joining",
  directDebitClubReopens: "Your monthly direct debit will start when the club reopens and will take into account any joining promotions in place",
  directDebitMandate: "Direct Debit Mandate",
  directDebitMembershipStarts: "Your first direct debit will start when your membership starts taking into account any promotions in place at time of joining",
  discoverTheCreche: "Discover the crèche",
  done: "Done",
  download: "Download",
  downloadAppPrompt: "To make bookings and manage your membership, please download the David Lloyd Clubs App.",
  downloadDescriptionMembershipVerification: "Download our mobile app before your visit so we can help you register and make the most of your membership.",
  downloadDescriptionTennis: "Download the app to view timetables, book classes and racquets courts wherever you are.",
  downloadDescriptionTrialConfirmation: "Download before your first visit so we can help you register and make the most of your membership.",
  downloadTheMobileAppHere: "Download the mobile app here:",
  dr: "Dr",
  duration: "Duration",
  edit: "Edit",
  email: "E-mail",
  emailAddress: "Email address",
  emailAddressesMustBeUnique: "Please enter a unique email address. It must be different to the email address provided by the primary member",
  emailContact: "E-mail",
  endsIn: "Ends in:",
  enjoyTimeTogetherAt: "Enjoy time together at %clubPrefix% %clubName%",
  enquireAboutMembership: "enquire about membership",
  enquireNow: "Enquire now",
  enquireText: "Tell us about your enquiry",
  enterALocation: "Enter a location...",
  enterAccountHolderName: "Please enter the name of the account holder",
  enterAccountNumber: "Please enter the account number",
  enterAtLeastTwoCharacters: "Please enter at least two characters",
  enterBIC: "Please enter the BIC",
  enterEmailAddress: "Please enter an email address",
  enterFirstName: "Please enter a first name",
  enterIBAN: "Please enter the account IBAN",
  enterLastName: "Please enter a last name",
  enterMobilePhoneNumber: "Please enter a mobile phone number",
  enterNameAsOnIdHint: "To help verify your identity smoothly, please enter your name as it appears on your national ID card or passport.",
  enterOrganisationError: "Please enter a company or group",
  enterPostcode: "Please enter a postcode",
  enterSortCode: "Please enter the sort code",
  enterValidAccountNumber: "Please enter a valid account number",
  enterValidBIC: "Please enter a valid BIC",
  enterValidDate: "Please enter a date",
  enterValidDateAfter: "Please enter a valid date on or after %date%",
  enterValidDateBefore: "Please enter a valid date on or before %date%",
  enterValidEmailAddress: "Please enter a valid email address",
  enterValidIBAN: "Please enter a valid IBAN",
  enterValidMobilePhoneNumber: "Please enter a valid mobile phone number",
  enterValidMobilePhoneNumberWithCountryCode: "Please enter a valid mobile phone number including country code (+XX)",
  enterValidName: "Please enter a valid name including a capital letter",
  enterValidOption: "Please select one of these options",
  enterValidPhoneNumber: "Please enter a valid phone number",
  enterValidPostCode: "Please enter a valid postcode",
  enterValidSortCode: "Please enter a valid sort code",
  enterValidTaxId: "Please enter a valid tax ID",
  enterValue: "Please enter a value",
  enterYourDetailsBelow: "Enter your details below",
  enterYourFirstName: "Please enter your first name",
  enterYourLastName: "Please enter your last name",
  equipmentAt: "Our equipment at %clubName%",
  exerciseClasses: "Exercise Classes",
  exerciseClassesAt: "Exercise classes at %clubName%",
  experienceAllTheBenefits: "Experience all the benefits of club membership.",
  expertPersonalTrainers: "Expert personal trainers",
  expertTuition: "Expert tuition",
  exploreClub: "Explore %clubName%",
  exploreKidsActivities: "Explore kids' activities",
  familyAmpersandKids: "Family & Kids",
  familyAndKids: "Family and kids",
  familyIncChild: "inc. your child",
  familyIncChildren: "inc. your children",
  familyIncInfant: "inc. your young child",
  familyIncInfants: "inc. your young children",
  familyIncNannies: "inc. your nannies",
  familyIncNanny: "inc. your nanny",
  familyIncOlderChild: "inc. your older child",
  familyIncOlderChildren: "inc. your older children",
  familyIncPartner: "inc. your partner",
  familyPackageMemberLimit: "Your family membership will include one partner and up to two children",
  familySwim: "Family swim",
  female: "Female",
  findAClub: "Find a Club",
  findOutMore: "Find out more",
  findYourClub: "Find your Club",
  firstFullMonth: "First full month",
  firstMonthFees: "As we are unable to set up your direct debit in time for your first full month, this payment is taken upfront",
  firstName: "First name",
  fitnessOverview: "Fitness overview",
  fixedTermFee: "Twelve months membership starting %month%",
  fixedTermFeeTooltip: "Payment covering the cost of membership for 12 calendar months",
  flexible: "Flexible",
  followedByMonthly: "Followed by monthly payment of",
  followedByMonthlyPaymentStarting: "Followed by monthly payment starting %date%",
  followedByMonthlyPaymentsDuringOffer: "Followed by monthly payments during special offer period until %date%",
  followedByMonthlyPaymentsTitle: "Followed by monthly payments",
  forNames: "For %nameList%",
  forYou: "For you",
  forYouAndFamily: "For you and your family",
  forYourChild: "For your child",
  forYourChildren: "For your children",
  forYourInfant: "For your young child",
  forYourInfants: "For your young children",
  forYourNannies: "For your nannies",
  forYourNanny: "For your nanny",
  forYourOlderChild: "For your older child",
  forYourOlderChildren: "For your older children",
  forYourPartner: "For your partner",
  free: "Free",
  frequentlyAskedQuestions: "Frequently Asked Questions",
  friendsAndFamilyReferralAlreadyUsed: "Sorry, this link has already been used. Please contact the person who referred you to nominate you again.",
  friendsAndFamilyReferralExpired: "Sorry, this link has expired. Please contact the person who referred you to nominate you again.",
  friendsAndFamilyReferralNotFound: "Sorry, this link was not found. Please contact the person who referred you to nominate you again.",
  from: "From",
  from3MonthsPlus: "from 3 mths +",
  from3To18Years: "from 3-18 years",
  gender: "Gender",
  germanAndFallbackOnly: "Test",
  getDirections: "Get directions",
  getInTouch: "Get in touch",
  getIntouchWithUs: "Get in touch with us",
  getStarted: "Get started",
  getYourQuoteContactPreferencesAfterPrivacyPolicy: "for full details. Just tick the box to keep in touch.",
  getYourQuoteContactPreferencesBeforePrivacyPolicy: "We'd love to keep in touch and tell you more about our latest products, services and offers. If you agree, just tick the box below. You can always change your mind at any time. Please see our",
  googleReview: "Based on %score% Google review",
  googleReviews: "Based on %score% Google reviews",
  groupExerciseClasses: "Group exercise classes",
  gym: "Gym",
  havingProblemsSavingMonthlyPaymentDetails: "We're having problems saving your monthly payment details",
  healthyBreakfast: "Healthy breakfast",
  heatedSwimmingPools: "Heated swimming pools",
  here: "here",
  highlightsAtClub: "Highlights at %clubPrefix% %clubName%*",
  hours: "hours",
  hoursLabel: "hours",
  howCanWeContactYou: "How can we contact you?",
  iAgree: "I agree",
  ifSomethingWereToChangeInYourLifestyle: "If something were to change in your lifestyle, %brandName% operates a 14 day cooling off period. Speak to a member of the team to find out more.",
  ifSomethingWereToChangeRightToCancel: "If something were to change in your lifestyle, you have the right to cancel. Speak to a member of staff to find out more.",
  imageDisclaimer: "*Disclaimer: images are for illustration only and may not be of the club you have selected.",
  importantInformation: "Important Information",
  includedInPromotion: "Included in Promotion",
  individual: "Individual",
  initialEnquiryKeepYouUpdated: "After your initial enquiry, we'd love to update you about our latest products, services and offers. Tick the boxes below to let us know how you'd like to hear from us.",
  initialMonthTerm: "Initial %monthDuration% calendar month term",
  isChildPresentText: "My child is in the Club with me today",
  isPartnerPresentText: "My partner is in the Club with me",
  join: "Join",
  joinAClubOnline: "Join a Club online",
  joinCorporate: "Join Corporate",
  joinCorporateTdr: "Join Corporate TDR",
  joinDifferentClub: "Join a different club",
  joinFamily: "Join Family",
  joinFriendsAndFamily: "Join Friends and Family",
  joinPleaseWaitCompleteMessage: "Done",
  joinPleaseWaitProgressMessages: "Getting you set up...\nNearly there...",
  joinPrivate: "Join Private",
  joinTodayAndSave: "Join today and save",
  joinYoungAdult: "Join Young Adult",
  joinedElsewhere: "Joined elsewhere",
  joiningAgreementTitle: "Joining Agreement",
  joiningFee: "Joining fee",
  joiningFeeFirstMonth: "Joining fee and first month",
  joiningFeeProRataFirstMonth: "Joining fee, remainder of first month and first full month",
  joiningFeeTooltip: "Payment to belong to the club",
  joiningFeeTwelveMonths: "Joining fee, remainder of the month and 12 calendar months membership",
  joiningFees: "Joining Fees",
  joiningFeesApply: "Joining fees apply",
  joiningFeesWaived: "SPECIAL OFFER - Joining fee saving now available",
  joiningTheClubAsAFamily: "Joining the club as a family",
  justMe: "Just me",
  keepAnEyeOnYourInboxForYourWelcomeEmail: "Keep an eye on your inbox for your welcome email — it will include your membership number and all the details you need to get started.",
  keepAnEyeOutForFutureTrials: "Please keen an eye on our website for future trials, or submit an enquiry and someone from the Club will be in touch.",
  keepInTouch: "Keep in touch",
  keepYouUpdated: "We'd love to update you about our latest products, services and offers. Tick the boxes below to let us know how you'd like to hear from us.",
  keepYouUpdatedDefaultOptedIn: "We’d love to keep you up to date with our latest products, services and offers. Simply untick the boxes below if you’d prefer not to hear from us.",
  kickstartTitleWithName: "%firstName%, how would you describe yourself?",
  kickstartTitleWithoutName: "How would you describe yourself?",
  kidsActivities: "Kids' activities",
  kidsBuildYourOwnPizza: "Kids build your own pizza",
  kidsClub: "Kids Club",
  lastName: "Last name",
  latestNews: "Latest News",
  learnMore: "Learn more",
  learnSomethingNew: "Learn something new",
  letThemEnjoyTheClub: "Let them enjoy the club while you take some time for yourself.",
  letUsKnowWhatYouAreInterestedIn: "Let us know what you're interested in so we can tailor your experience",
  letUsKnowWhatYouAreLookingForwardTo: "Let us know what areas of the club you are most looking forward to using",
  letUsKnowWhyCancel: "Please let us know why you have chosen to cancel your booking:",
  linkIsInvalid: "Sorry, this link is invalid",
  loadingClubWelcomeTimes: "Loading club welcome times...",
  loadingTourTimes: "Loading tour times...",
  location: "Location",
  locationNotFound: "Location not found. Please try again.",
  logOut: "Log out",
  login: "Login",
  male: "Male",
  manageYourTour: "Manage your tour",
  manageYourTourPageTitle: "Manage Your Tour | %displayName%",
  master: "Master",
  meAndMyFamily: "Me + my family",
  meAndMyPartner: "Me + my partner",
  members: "Members",
  membersLogin: "Member's login",
  membership: "Membership",
  membershipDescription: "Located within your welcome email or on your membership card",
  membershipDiscountUntil: "Until %date%",
  membershipEnquiryDetails: "The user selected: %duration%%packageKey%%packageTypes%",
  membershipFees: "Membership fees",
  membershipFeesUpUntil: "Membership fees up until %date%",
  membershipLimitReached: "The limit has been reached for this membership type",
  membershipNotOpenClubPopupDescription: "This Club is not yet open. More information about membership options and access to other Clubs will be available in due course. Please check back for more updates.",
  membershipNumber: "Membership number",
  membershipPlaceholder: "Please enter your membership number",
  membershipSaving: "Membership Saving",
  membershipSelected: "Membership selected: %package% (%duration%)",
  membershipStartClubConfirm: "Your club will confirm when your membership starts",
  membershipStartClubOpens: "Your membership will start when the club opens",
  membershipTermsAndConditions: "Membership T&Cs",
  membershipTrial: "Membership Trial",
  memberships: "Memberships",
  min: "min",
  minutes: "minutes",
  minutesLabel: "minutes",
  miss: "Miss",
  month: "Month",
  monthContract: "%monthDuration% month contract",
  monthlyDirectDebitsStartOn: "Monthly direct debit payments to start on",
  monthlyFee: "Monthly Fee",
  monthlyFeeBeforeInitialTerm: "Monthly Fee (before initial term starts on %initialTermStartDate%)",
  monthlyFeeBeforeInitialTermPreSale: "Monthly Fee",
  monthlyFeeDuringPromotionalTerm: "Monthly Fee (%lengthInMonths% months)",
  monthlyFeeThereafter: "Monthly Fee (thereafter)",
  monthlyFeeWillBeTakenByDD: "Monthly Fee will be taken by Direct Debit starting %date%.",
  monthlyFeeWillBeTakenByDDPreSale: "Monthly Fee will be taken by Direct Debit.",
  monthlyFeeWillBeTakenBySEPA: "Monthly Fee will be taken by SEPA starting %date%.",
  monthlyFeeWillBeTakenBySEPAPreSale: "Monthly Fee will be taken by SEPA.",
  monthlyPaymentsDuringOfferPeriodTitle: "Monthly payments during special offer period",
  monthlySavings: "Monthly Savings",
  monthlyVipSpaGuestPassInfo: "Complimentary guest pass to share every month, including Spa Retreat access.",
  months: "months",
  more: "More",
  moreDetailsSkipDirectDebit: "I want to set up my Direct Debit in Club",
  moreDetailsSkipSEPA: "I want to set up my SEPA Direct Debit in Club",
  mostPopular: "Most popular",
  mostRecent: "Most Recent",
  mr: "Mr",
  mrs: "Mrs",
  ms: "Ms",
  mustAcceptJoiningAgreementBeforeContinuing: "You must accept the joining agreement before you can continue.",
  mx: "Mx",
  myMembership: "My membership",
  nearbyClubs: "Nearby Clubs",
  nearestClub: "Here are the nearest David Lloyd Clubs to",
  nearlyThere: "Nearly there",
  next: "Next",
  noAdditionalMembershipsAvailable: "There are no additional membership options currently available.",
  noAvailableOptions: "There are no available options.",
  noAvailablePromotions: "There are no available promotions.",
  noClubWelcomeSlotsError: "Unfortunately, we do not have any club welcome times available online at the moment. Please get in touch, and we will find you a time",
  noClubsInClubFinder: "There are no clubs in this area, however clubs closest to you are listed below.",
  noJoiningFee: "No Joining Fee",
  noJoiningFeeOffer: "Special Offer: No joining fee",
  noLongerInterested: "No longer interested",
  noMembershipFeeForMonthOffer: "Bonus Offer: No membership fee for %month%",
  noPreferencePackageKey: "no preference for membership package type; ",
  noPreferencePackageTypes: "no preference for membership access type.",
  noTourSlotsError: "Unfortunately, we do not have any tour times available online at the moment. Please get in touch, and we will find you a time",
  nonMembers: "Non-Members",
  normally: "Normally",
  notAllMembershipsAvailable: "Not All Memberships Available",
  notSureWhichClubsNearest: "Not sure which Club's nearest",
  now: "Now",
  onDate: "on %date%",
  onJoiningTheClubPayment: "On joining the club you will be asked to make an initial payment comprising of a joining fee and a pro rata payment (this is your payment today). This is followed by a monthly subscription that will be taken by direct debit. If you wish to enhance your membership experience you can add on additional products such as personal training or coaching, this can also be paid today.",
  oneMonth: "One month",
  onlyAvailableForALimitedTime: "Only available for a limited time",
  openingHours: "Opening hours",
  openingTimes: "Opening times",
  optInToSpecialOffer: "Add this to opt in to the joining promotion",
  optOutAtAnyTimeAfterPrivacyPolicy: "for full details",
  optOutAtAnyTimeAfterPrivacyPolicyMeridian: "Information about the processing of your personal data in connection with the newsletter and text messaging can be found",
  optOutAtAnyTimeBeforePrivacyPolicy: "You can opt-out at any time. See our",
  optional: "Optional",
  options: "Options",
  organisation: "Organisation",
  organisationOther: "Other",
  other: "Other",
  ourClubsInEurope: "Our Clubs in Europe",
  ourEquipmentAt: "Our equipment at %clubName%",
  ourFriendlyTeamAreLookingForwardToMeetingYou: "Our friendly team are looking forward to meeting you",
  ourTeamIsLookingForwardToMeetingYou: "Our team is looking forward to meeting you!\nYou'll shortly receive a confirmation email with the details of your new booking.",
  outdoorPoolTimesWeatherDependent: "Our outdoor pool times are weather dependent",
  over14EmailAddress: "Members over 14 can use in-club facilities. Enter their email address so they can be enrolled.",
  over14PhoneNumber: "Members over 14 can use the %brandName% mobile app, please enter their mobile number.",
  "package": "Package",
  packageSelected: "%packageName% selected",
  padel: "Padel",
  paidOnline: "Paid online",
  partner: "Partner",
  partnerEmail: "Your partner will be sent an email confirming their membership details & to complete their membership set up. Enter their mobile number & we will send a link to register to the %brandName% mobile app.",
  partnerWasReset: "Unfortunately this package doesn't have a partner option - please look at upgrading to another package to include your partner.",
  partnersAndSponsors: "Partners & Sponsors",
  password: "Password",
  passwordPlaceholder: "Please enter your password",
  payAnnually: "Pay annually",
  payAtReception: "Pay at reception",
  payMonthly: "Pay monthly",
  payOnline: "Pay online",
  payingAnnually: "Paying annually is typically cheaper than paying monthly",
  paymentDetails: "Payment details",
  paymentLinkExpired: "Payment link expired",
  paymentReceived: "Payment received",
  paymentRefused: "Payment refused",
  paymentVerificationErrorContactClub: "We were unable to verify your payment details. Please try again, or contact the Club via %email%.",
  paymentVerificationErrorSpeakToTeam: "We were unable to verify your payment details. Please try again, or speak to a member of the team.",
  penneArrabbiata: "Penne arrabbiata",
  perMonth: "per month",
  personalInformation: "Personal Information",
  personalisedWellnessTestingInfo: "Full health screening powered by our partner Latus Longevity, including blood tests, functional diagnostics and lifestyle review.",
  phoneNumber: "Mobile phone number",
  phoneNumbersMustBeUnique: "Please enter a unique phone number. It must be different to the phone number provided by the primary member",
  pickAnotherTime: "Pick another time",
  placeholderTemplate: "e.g. %example%",
  pleaseCheckAndTryAgain: "Please check and try again",
  pleaseCheckYourCardDetails: "Please check your card details",
  pleaseCheckYourDetailsAndTryAgain: "Please check your details and try again. If the problem persists, visit us in club and our team will be happy to help you.",
  pleaseCheckYourEmail: "Please check your email",
  pleaseChooseAClub: "Please choose a club",
  pleaseClickHereTo: "Please click here to",
  pleaseConfirmThatPaymentWillBeMadeAtReception: "Please confirm that payment will be made at reception",
  pleaseContactOnlineJoining: "Please contact %email% for assistance",
  pleaseDoubleCheckAndTryAgain: "Please double check your details and try again",
  pleaseEnterANumber: "Please enter a number",
  pleaseMakePaymentAtReception: "Please make payment at reception",
  pleasePickAnotherTime: "Please pick another time.",
  pleaseRefreshOrTryAgainLater: "Please refresh, or try again later",
  pleaseSelectATime: "Please select a time",
  pleaseTryAgainLater: "Please try again later",
  pleaseUseAnAlternativeBrowser: "Please use an alternative browser, such as an updated version of Microsoft Edge, Google Chrome or Safari",
  pleaseVerifyCaptcha: "Please verify the captcha to continue",
  policies: "Policies",
  policiesAndDocuments: "Policies & documents",
  poolOpeningHours: "Pool opening hours",
  poolOpeningTimes: "Pool opening times",
  poolTimes: "Pool times",
  pools: "Pools",
  poolsAreClosed: "All our pools are currently closed.",
  postCode: "Postcode",
  postCodePlaceholder: "Enter your postcode",
  postcodeNoResults: "No matching postcodes found",
  preferNotToSay: "Rather not say",
  presalesWindowClosed: "Sorry you missed out; our Early Memberships window has closed for now. If you haven’t already registered, please click the button above and we’ll make sure to send you a reminder when the next chance to join opens.",
  press: "Press",
  pressCentre: "Press Centre",
  previous: "Previous",
  priceDuringPromotionalPeriod: "price during promotional period",
  pricePerAdult: "%adultPrice% per adult",
  pricePerChild: "%childPrice% per child",
  primaryMember: "Primary member",
  priorityBookingInfo: "Enjoy an extra day’s booking rights and book classes and courts 10 days in advance (Home Club only)",
  privacyPolicy: "Privacy Policy",
  promotionApplied: "Promotion applied",
  promotionSelected: "Promotion selected",
  qrCodeExpired: "QR code expired - please pay at reception",
  qty: "Qty",
  quantity: "Quantity",
  quickRegistration: "Quick Registration",
  rearrange: "Rearrange",
  rearrangeYourTourOf: "Rearrange your tour of %clubPrefix% %clubName%.",
  recentlyViewedClub: "Recently viewed Club",
  recentlyVisitedClub: "Recently visited Club",
  reducedJoiningFee: "Reduced joining fee",
  refundedIfYouJoinOnAStandardMembership: "fee payable if you do not join on a standard membership",
  regionUnitedKingdomEast: "East",
  regionUnitedKingdomGreaterLondon: "Greater London",
  regionUnitedKingdomMidlands: "Midlands",
  regionUnitedKingdomNorthEast: "North East",
  regionUnitedKingdomNorthWest: "North West",
  regionUnitedKingdomNorthernIreland: "Northern Ireland",
  regionUnitedKingdomScotland: "Scotland",
  regionUnitedKingdomSouth: "South",
  regionUnitedKingdomSouthEast: "South East",
  regionUnitedKingdomSouthWest: "South West",
  regionUnitedKingdomWales: "Wales",
  registerForClubTrial: "Start your 14 day trial today",
  registerForClubTrialButton: "Start your trial",
  registrationErrorMessage: "Please check your details are correct. If you are having trouble registering for an account, please drop us an email at <a style=\"color: %emailColor%;\" href=\"mailto:%email%\">%email%</a> and someone will get back to you as soon as possible.",
  registrationUnauthorised: "Authorisation failed",
  relaxAmpersandSocialise: "Relax & Socialise",
  relaxAndEnjoySpaRetreats: "Relax and enjoy Spa Retreats",
  relaxAndSocialise: "Relax and socialise",
  remainderOfFirstMonth: "Remainder of first month",
  remainderOfFirstMonthAnd12MonthsMembership: "Remainder of first month and 12 calendar months membership",
  remainderOfFirstMonthAndFirstFullMonth: "Remainder of first month and first full month",
  remainderOfThisMonth: "Remainder of this month",
  remainderOfThisMonthTooltip: "Payment covering the cost of membership for the remainder of this month",
  remove: "Remove",
  removeNonNumeric: "Please remove any non-numeric characters",
  removeSpecialCharacters: "Please remove special character(s) from the field:",
  requestingAClubWelcome: "Requesting a club welcome appointment",
  requiredInformation: "Required information",
  retry: "Retry",
  saveAmount: "Save %amount%",
  savingUpTo: "Saving up to %price%*",
  scanQrCodeToDownload: "Scan the QR code to download the App",
  scanQrCodeToPay: "Scan the QR code to proceed to payment page",
  searchForADifferentAddress: "Search for a different address",
  seconds: "seconds",
  secondsLabel: "seconds",
  seeAllFacilities: "See all facilities",
  seeDetails: "See details",
  selectACompany: "To get started, please select your company from the list below",
  selectACountryBelow: "Select a country below to find the Club you'd like to join.",
  selectADate: "Select a date",
  selectAddressError: "Please select your address from the list, or add it manually if you can't find it.",
  selectAGender: "Select a gender",
  selectAnOrganisation: "Select a company or group...",
  selectOptionsBelow: "Select from the options below to find activities for the whole family.",
  selectOrganisationError: "Please select a company or group",
  selectPackage: "Select %packageName%",
  selectPlaceholder: "Select from the list",
  selectPromotion: "Select promotion",
  selectTitle: "Select a title...",
  selectValidClub: "Please select a club from the dropdown",
  selected: "Selected",
  selectedDuration: "a %durationType% package duration; ",
  selectedPackageKey: "a %packageKey% membership; ",
  selectedPackageTypes: "membership access that includes %packageTypes%.",
  selectedTourTimeNoLongerAvailable: "Unfortunately, the tour time you selected is no longer available.",
  selectedTourTimeNoLongerAvailableHeader: "Tour time not available",
  sendQuote: "Send quote",
  sepaGuaranteeLine1: "By signing this mandate form, you authorize (A) %companyName% to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from %companyName%",
  sepaGuaranteeLine2: "As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank.",
  sepaGuaranteeLine3: "A refund must be claimed within 8 weeks starting from the date on which your account was debited.",
  sepaGuaranteeLine4: "Your rights regarding this mandate are explained in a statement that you can obtain from your bank.",
  sepaGuaranteeLine5: "Type of Payment: Recurrent (can be used more than once)",
  sepaTitle: "SEPA Direct Debit Mandate",
  servicesAndFacilities: "Services and facilities",
  settingUpYourDirectDebit: "Setting up your direct debit",
  settingUpYourMonthlyPayment: "Setting up your monthly payment",
  shareOnFacebook: "Share on Facebook",
  shareOnTwitter: "Share on Twitter",
  signMeUp: "Sign me up",
  signUpForAGradeCoaching: "Sign up for A-grade coaching for all ages",
  sitemap: "Sitemap",
  skipDigitalSignature: "Continue without digital signature",
  skipPayment: "Skip payment, I would like to pay at reception",
  slotsTakingAWhileToLoad: "It's taking a while to find our available slots. We'll keep trying, but in the meantime, you can get in touch directly using the details below",
  snrgyFamilyFitness: "Synrgy family fitness",
  socialMedia: "Social Media",
  softPlay: "Soft play",
  somethingHasGoneWrong: "Something has gone wrong",
  sorryIeNotSupported: "Sorry, Internet Explorer is not supported",
  sorrySomethingHasGoneWrongPleaseTryAgain: "Sorry, something has gone wrong. Please try again.",
  sorrySomethingWentWrong: "Sorry, something went wrong.",
  sorryThereWasAProblemWithYourPayment: "Sorry, there was a problem with your payment",
  sorryWereHavingTechnicalProblems: "Sorry, we're having technical problems",
  sorryYouMissedYourAppointment: "Sorry, you missed your appointment.",
  sortBy: "Sort by:",
  sortByMyLocation: "Sort by my location",
  sortCode: "Sort code",
  spa: "Spa",
  specialHours: "Special hours",
  specialOffer: "Special offer",
  specialsAndEvents: "Specials und Events",
  sportsOverview: "Sports overview",
  standard: "Standard",
  startBetweenFixedDates: "You may start your membership between %start_date% and %end_date%",
  startDate: "Start date",
  startOnFixedDate: "You may start your membership on",
  startThisMonth: "Start your membership anytime this month",
  stateOfTheArtGymFacilities: "State of the art gym facilities",
  studioOpeningHours: "Studio opening hours",
  studioOverview: "Studio Overview",
  submitAndStartMembership: "Submit & start enjoying my membership",
  swimmingAt: "Swimming at %clubName%",
  swimmingCoaching: "Swimming coaching",
  swimmingPools: "Swimming Pools",
  tailorYourClubWelcome: "Tailor your club welcome",
  tailorYourTour: "Tailor your tour",
  takeOurVideoTour: "Watch our video to get a feel for the %brandName% experience*",
  takeTheNextStep: "Take the next step",
  takeTheNextStepDescription: "Discover how joining %clubPrefix% %clubName% could transform your health and wellbeing.",
  taxId: "Tax ID",
  telephone: "Telephone",
  temporarilyNoMembershipsAvailable: "We’re not currently offering online memberships at the moment, but we’d love to welcome you soon. Please get in touch with your local club and our team will be happy to talk you through your options and help you become part of David Lloyd Clubs.",
  tennis: "Tennis",
  tennisClub: "Tennis Club",
  tennisCoaching: "Tennis Coaching",
  termsAndConditions: "Terms and Conditions",
  textMessage: "Text Message",
  thankYouForSettingUpDirectDebit: "Thank you for setting up your Direct Debit with us",
  thankYouForSubscribing: "Thank you for subscribing!",
  thankYouWelcomeToBrand: "Thank you, Welcome to %brandName%!",
  theClub: "The club",
  thereAreCurrentlyNoMembershipPackages: "Sorry you missed out; our Early Memberships window has closed for now. If you haven’t already registered, please click the button above and we’ll make sure to send you a reminder when the next chance to join opens.",
  threeMonths: "3 months",
  time: "Time",
  timetable: "Timetable",
  title: "Title",
  to: "to",
  today: "today",
  tomorrow: "tomorrow",
  total: "Total",
  totalCumulativePriceForAnnualMembership: "Total cumulative price for a Standard membership: Total due today (initial term starting %initialTermStartDate%).",
  totalCumulativePriceForAnnualMembershipPreSale: "Total cumulative price for a Standard membership: Total due today.",
  totalCumulativePriceForFlexibleMembership: "Total cumulative price for a Flexible membership: Total due today, followed by 3 full monthly payments (initial term starting %initialTermStartDate%).",
  totalCumulativePriceForFlexibleMembershipPreSale: "Total cumulative price for a Flexible membership: Total due today, followed by 3 full monthly payments.",
  totalCumulativePriceForStandardMembership: "Total cumulative price for a Standard membership: Total due today, followed by 12 full monthly payments (initial term starting %initialTermStartDate%).",
  totalCumulativePriceForStandardMembershipPreSale: "Total cumulative price for a Standard membership: Total due today, followed by 12 full monthly payments.",
  totalDueToday: "Total due",
  totalMonthlyPrice: "Total monthly price",
  totalSavedJoiningToday: "Total savings by joining today",
  tourDetails: "Tour details",
  tourSuccessfullyUpdated: "%name%, your tour has been successfully updated.",
  townOrCity: "Town/City",
  townOrCityPlaceholder: "Enter your town or city",
  travel: "Travel",
  treatments: "Face & Body Day Spa",
  treatmentsOverview: "Treatments overview",
  twelveMonthsMembership: "12 calendar months membership",
  unableToOfferTrial: "Sorry, we're not offering a trial at the moment.",
  unableToTakeClubWelcomeBookings: "Unfortunately, we're unable to take online bookings at the moment - you can get in touch with us via the details below to book your club welcome.",
  unableToTakeTourBookings: "Unfortunately, we're unable to take online bookings at the moment - you can get in touch with us via the details below to book your tour.",
  unexpectedError: "Unexpected error",
  unfortunatelyAnErrorHasOccurred: "Unfortunately, an error has occurred",
  unfortunatelyThisTimeIsNoLongerAvailable: "Unfortunately, this time is no longer available.",
  unitPrice: "Unit Price",
  unknownMembershipError: "Your membership may have been successfully recorded. Please check for a confirmation E-mail. If you do not receive one within an hour, then please try again.",
  upgradeYourMembershipToAddChildren: "Upgrade your membership to add a child",
  upgradeYourMembershipToAddPartner: "Upgrade your membership to add a partner",
  useMyLocation: "Use my location",
  useYourCurrentLocation: "Use your current location",
  userAlreadyExists: "This membership number is already in use",
  userInputOrganisation: "What is your company or group name?",
  userVerificationFailed: "Verification failed",
  usualJoiningFees: "Usual joining fees",
  viewAgreement: "View Agreement",
  viewAllClubs: "View all Clubs",
  viewClub: "View Club",
  viewClubsAccessText: "View Clubs I can access",
  viewContactOption: "View contact options",
  viewInMaps: "View in maps",
  viewOurFoodMenu: "View our food menu",
  viewOurOpeningHours: "View our opening times",
  viewTimetable: "View timetable",
  visitSpaRetreats: "Visit Spa Retreats",
  wantToBookANewTour: "Want to book a new one? Just hit the button below.",
  was: "Was",
  weAlreadyHaveYourDetails: "%firstName%, we already have your details in our system.",
  weDontRecogniseThatLocation: "Sorry, we don't recognise that location",
  weJustNeedAFewMoreDetails: "We just need a few more details",
  weSendOurMostExcitingOffers: "Don’t miss out! We send our most exciting offers by email ",
  weWereUnableToSaveDetails: "Sorry, we were unable to save your details",
  weekend: "Weekend",
  weeklyTimetable: "Weekly timetable",
  welcomeTo: "Welcome to",
  wereSorryYouCanNoLongerVisit: "We're sorry you can no longer visit the Club.",
  whatToExpect: "What to expect?",
  whatsApp: "WhatsApp",
  whereToFindUs: "Where to find us",
  whoCanCome: "Who can come?",
  whosComing: "Who's coming?",
  workEmailAddress: "Work Email Address",
  years: "years",
  youCanScheduleANewTour: "You can schedule a new tour when you're ready.",
  youngChildren: "Young Children",
  yourCardDetails: "Your card details",
  yourChild: "Your child (%range%)",
  yourChildren: "Your children (%range%)",
  yourClub: "Your Club",
  yourClubWelcomeIsBooked: "%name%, your club welcome is booked",
  yourDetails: "Your details",
  yourFirstFullMonth: "Your first full month (%month%)",
  yourFirstFullMonthTooltip: "Payment covering the cost of membership until your direct debit has been set up with your bank",
  yourMembership: "Your membership",
  yourMembershipStartsOn: "Your membership starts on",
  yourMembershipTrial: "Your Membership Trial",
  yourNannies: "Your nannies",
  yourNanny: "Your nanny",
  yourOlderChild: "Your older child (%range%)",
  yourOlderChildren: "Your older children (%range%)",
  yourPartner: "Your partner",
  yourSavings: "Your Savings",
  yourSavingsSubtitle: "Here's what you can save by joining today:",
  yourStartDate: "Your start date",
  yourTourHasBeenCancelled: "%name%, your tour has been cancelled.",
  yourTourIsBooked: "%name%, your tour is booked",
  yourYoungChild: "Your young child (%range%)",
  yourYoungChildren: "Your young children (%range%)"
};
